import { render, staticRenderFns } from "./onePaperListDialog.vue?vue&type=template&id=f5eaf5d2"
import script from "./onePaperListDialog.vue?vue&type=script&lang=js"
export * from "./onePaperListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports